import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { LoungesService } from 'src/app/api/restaurant/lounges.service';
import { GeneralService } from 'src/app/api/config/general.service';
declare var $: any;

@Component({
  selector: 'app-lounges-tables',
  templateUrl: './lounges-tables.component.html',
  styleUrls: ['./lounges-tables.component.css']
})
export class LoungesTablesComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  detail_tables: any = [];
  tabletypes: any = [];
  default_tabletype: any = 1;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private loungesService: LoungesService,
    private generalService: GeneralService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      is_show: [true]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getTableTypes();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.loungesService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        console.log(item_);
        this.item.patchValue({
          description: item_.description,
          is_show: item_.is_show
        });
        //  asignar mesas al detalle
        this.detail_tables = item_.tables;
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getTableTypes(){
    this.generalService.listTableTypes().subscribe({
      next: (data: any) => {
        this.tabletypes = data.results;
        this.default_tabletype = this.tabletypes[0].id;
      }
    });
  }

  addTable() {
    let obj_: any = {};
    obj_.id = null;
    obj_.loungesrestaurant_id = this.checkId;
    obj_.tabletype_id = this.default_tabletype;
    obj_.number_table = null;
    obj_.code_table = null;
    obj_.capacity = null;
    obj_.tag = null;
    obj_.observation = null;
    this.detail_tables.push(obj_);
    setTimeout(() => {
      let last_index = this.detail_tables.length - 1;
      (<any>$('#number_table' + last_index)).focus();
    }, 150);
  }

  changeNumberTable(param: any, index: number): void {
    let value_ = param.value;
    this.detail_tables[index].number_table = value_;
  }

  changeTableTypeSelected(param: any, index: number): void {
    let value_ = param.value;
    this.detail_tables[index].tabletype_id = value_;
  }

  changeCapacity(param: any, index: number): void {
    let value_ = param.value;
    this.detail_tables[index].capacity = value_;
  }

  changeCodeTable(param: any, index: number): void {
    let value_ = param.value;
    this.detail_tables[index].code_table = value_;
  }

  changeObservation(param: any, index: number): void {
    let value_ = param.value;
    this.detail_tables[index].observation = value_;
  }

  removeTable(id: any, index: any) {
    this.detail_tables.splice(index, 1);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    data.item = this.item.value;
    data.detail_tables = this.detail_tables;

    if (this.validate()) {

      this.loungesService.updateTables(this.checkId, data).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success(
            'Registro de mesas realizado con éxito'
          );
        }
      });
    }
  }

  validate() {
    if (this.detail_tables.length > 0) {
      for (let i in this.detail_tables) {
        let item_ = this.detail_tables[i];
        if (_.isNull(item_.number_table)) {
          (<any>$('#number_table' + i)).focus();
          this.alertifyMsg.warning(
            'El número de mesa no puede estar vacío' + i
          );
          return false;
        }
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/restaurante/ambientes_mesas/lista'
    ]);
  }
}
